/**
 *
 *  @param {REDUX/Action} findAddressTrigger
 *  @param {REDUX/Action} getAddressTrigger
 *  @param {REDUX/State} address
 *  @param {function} setAddress [Function to returns the address]
 *
 */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Libraries
 */
import './styles/Address.css'

/**
 *     Import
 *     - Components
 */
import Checkbox from '../Checkbox/Checkbox'
import AddressList from './components/AddressList'
import AddressInputField from './components/AddressInputField'
import Autocomplete from '../Autocomplete'
import { verifyPostcode } from '../../../helpers/address'
import { SearchOrangeIcon } from '../../../images/icons/Search/SearchOrange'

/**
 *     Form HTML
 */
export default class AddressLookup extends React.Component<any, any> {

    private postcodeFindInput

    constructor(props: any) {
        super(props)
        this.state = {
            addressListVisible: false,
            addressDetailsVisible: false,
            addressManual: false,
            addressVisible: false,
            address: {
                addressLine1: '',
                addressLine2: '',
            },
            museums: [],
            museumValue: '',
            storageLocations: [],
            storageLocationValue: '',
            museum: '',
            storageLocation: '',
            city: '',
            unit: '',
            floor: '',
            postcode: '',
            isMuseumSectionLocked: false,
            isStorageLocationSectionLocked: false,
        }
    }

    componentDidMount(): void {
        this.props.fetchMuseums()
        this.props.fetchStorageLocations()
    }

    /**
     * Check if the value typed into input field is valid as a UK postal code
     * It uses the UK Gov Regex code to check it.
     * @param  {event} postcode: [Input field change event used to get it value]
     */
    verifyPostcode = (postcode: any) => {
        var match = verifyPostcode(postcode)
        if (match) {
            this.checkAddress(match)
            this.setState({ addressListVisible: true })
        }
    }

    /**
     * listener used to manage the visibility of fields
     * when the Manual Address checkbox is triggered
     */
    componentWillUpdate(nextProps: any, nextState: any) {
        if (nextState.addressManual !== this.state.addressManual) {
            this.setState({ addressVisible: nextState.addressManual })
        }

        if (this.state.addressListVisible &&
            nextProps.address.findAddress.done &&
            nextProps.address.findAddress.response[0].Error) {
            this.setState({ addressListVisible: false })
        }

        if (nextProps.address.getAddress.response !== this.props.address.getAddress.response
            && nextProps.address.getAddress.response !== undefined) {

            const r = nextProps.address.getAddress.response

            // // setAddress(name, value)
            this.props.setAddress('addressLine1', this.setAddress(1, r))
            this.props.setAddress('addressLine2', this.setAddress(2, r))
            this.props.setAddress('city', r.City)
            this.props.setAddress('postcode', r.PostalCode)
        }

        if (nextProps.address.getLatLong.response !== this.props.address.getLatLong.response
            && nextProps.address.getLatLong.response !== undefined) {

            const r = nextProps.address.getLatLong.response
            this.props.setAddress('lat', r.latitude)
            this.props.setAddress('lng', r.longitude)
        }
    }

    componentDidUpdate( prevProps: Readonly<any>, prevState: Readonly<any>, prevContext: any ): void {
        if (this.props.isAddressLookupByTermShown !== prevProps.isAddressLookupByTermShown) {
            this.setState({addressManual: false})
        }
        if (this.props.address.museums !== prevProps.address.museums && this.props.address.museums.data.length > 0) {
            this.setState({museums: this.props.address.museums.data})
        }
        if (
            this.props.address.storageLocations !== prevProps.address.storageLocations &&
            this.props.address.storageLocations.data.length > 0
        ) {
            this.setState({storageLocations: this.props.address.storageLocations.data})
        }
        if (
            this.props.addressType !== prevProps.addressType ||
            this.props.countryId !== prevProps.countryId
        ) {
            this.setState({
                addressListVisible: false,
                addressDetailsVisible: false,
                addressManual: false,
                address: {
                    addressLine1: '',
                    addressLine2: '',
                },
                museums: [],
                museumValue: '',
                storageLocations: [],
                storageLocationValue: '',
                museum: '',
                storageLocation: '',
                city: '',
                unit: '',
                floor: '',
                postcode: '',
                isMuseumSectionLocked: false,
                isStorageLocationSectionLocked: false,
            })
        }
    }

    checkAddress = (postcode: any) => this.props.findAddressTrigger(postcode)

    /**
     * Action triggered when an address line is selected
     * @param  {object} address [Object with the ID, and address line info]
     */
    selectAddress = (address: any) => {

        this.props.getAddressTrigger(address.Id)
        this.props.getLatLongTrigger(this.postcodeFindInput.value)

        // Clean input from the postcode finder
        this.postcodeFindInput.value = ''

        this.setState({ addressListVisible: false, addressVisible: true })

    }

    /**
     * Returns the Line1 and Line2 on the form
     * function picks the 5 lines returned by API
     * and split all those 5 into only 2 lines.
     * @param {number} line [Line number]
     */
    setAddress = (line: number, response: any = null) => {

        const address = response || this.props.address.getAddress.response

        let Line1, Line2

        if (address.Line4 !== '') {
            Line1 = (address.Line1 && address.Line2) ? `${address.Line1}, ${address.Line2}` : ''
            Line2 = (address.Line3 && address.Line4) ? `${address.Line3}, ${address.Line4}` : ''
        } else if (address.Line3 !== '') {
            Line1 = (address.Line1 && address.Line2) ? `${address.Line1}, ${address.Line2}` : ''
            Line2 = (address.Line3) ? `${address.Line3}` : ''
        } else if (address.Line5 !== '') {
            Line1 = (address.Line1 && address.Line2) ? `${address.Line1}, ${address.Line2}` : ''
            Line2 = (address.Line3 && address.Line4) ? `${address.Line3}, ${address.Line4}, ${address.Line5}` : ''
        } else {
            Line1 = (address.Line1) ? `${address.Line1}` : ''
            Line2 = (address.Line2) ? `${address.Line2}` : ''
        }

        if (line === 1) {
            return Line1
        } else {
            return Line2
        }

    }

    /**
     * Function to handle the change on each Manual Address input
     * @param  {event} e [change event]
     */
    handleChange = (e: any, args: {name: string, value: any}) => {
        /**
         * If we don't change the done field of the call, it will replace the address input
         * with the value of the last response instead of the new one that the user is tapping
         */
        this.props.address.getAddress.done = null

        if (e.target.name === 'addressLine1') {
            this.setState({ address: { addresLine1: e.target.value } })
        } else if (e.target.name === 'addressLine2') {
            this.setState({ address: { addresLine2: e.target.value } })
        }
        if (args) {
            this.props.setAddress( args.name, args.value )
        } else {
            this.props.setAddress( e.target.name, e.target.value )
        }
    }

    /**
     * Handle the Manual Address checkbox
     */
    handleCheckbox = (state: any, name: any) => this.setState({ addressManual: state })

    getMuseums = value => {
        const inputValue = value.trim().toLowerCase()
        const inputLength = inputValue.length

        return inputLength === 0 ? [] : this.props.address.museums.data.filter(museum =>
            museum.facilityName.toLowerCase().indexOf(inputValue) !== -1 &&
            museum.countryId === this.props.countryId
        )
    }

    getStorageLocations = value => {
        const inputValue = value.trim().toLowerCase()
        const inputLength = inputValue.length

        return inputLength === 0 ? [] : this.props.address.storageLocations.data.filter(storageLocation =>
            storageLocation.facilityName.toLowerCase().indexOf(inputValue) !== -1 &&
            storageLocation.countryId === this.props.countryId
        )
    }

    getMuseumValue = suggestion => suggestion.facilityName

    getStorageLocationValue = suggestion => suggestion.facilityName

    renderSuggestion = suggestion => (
        <div>
            {suggestion.facilityName}
        </div>
    )

    onMuseumChange = (event, { newValue }) => {
        this.props.setAddress('museum', newValue)
        this.setState({
            museumValue: newValue,
        })
    }

    onMuseumSelected = (event, {suggestion}) => {
        this.handleChange(event, {name: 'city', value: suggestion.city})
        this.setState({
            city: suggestion.city,
            isMuseumSectionLocked: true,
        })
    }

    onStorageLocationChange = (event, { newValue }) => {
        this.props.setAddress('storageLocation', newValue)
        this.setState({
            storageLocationValue: newValue,
        })
    }

    onStorageLocationSelected = (event, {suggestion}) => {
        this.handleChange(event, {name: 'city', value: suggestion.city})
        this.setState({
            city: suggestion.city,
            isStorageLocationSectionLocked: true,
        })
    }

    onMuseumsFetchRequested = ({ value }) => {
        this.setState({
            museums: this.getMuseums(value),
        })
    }

    onMuseumsClearRequested = () => {
        this.setState({
            museums: [],
        })
    }

    onStorageLocationsFetchRequested = ({ value }) => {
        this.setState({
            storageLocations: this.getStorageLocations(value),
        })
    }

    onStorageLocationsClearRequested = () => {
        this.setState({
            storageLocations: [],
        })
    }

    render() {
        const {
            isAddressLookupByTermShown,
            addressType,
            address,
        } = this.props
        const {
            museums,
            museumValue,
            storageLocations,
            storageLocationValue,
            city,
            unit,
            floor,
        } = this.state
        const { loading, done, response } = address.findAddress

        switch (addressType) {
            case 'museum':
                return (
                    <div className="quote__form__group form__w100 address">
                        <div className="quote__form__group form__w100 address__lookup wrap_margin">
                            <Autocomplete
                                suggestions={museums}
                                onSuggestionsFetchRequested={this.onMuseumsFetchRequested}
                                onSuggestionsClearRequested={this.onMuseumsClearRequested}
                                getSuggestionValue={this.getMuseumValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={{
                                    placeholder: 'Find museum by name',
                                    value: museumValue,
                                    onChange: this.onMuseumChange,
                                }}
                                onSuggestionSelected={this.onMuseumSelected}
                            />
                        </div>

                        <div
                            className="address__details form__w100 active"
                        >

                            <AddressInputField
                                className="form__w100"
                                name="city"
                                id="city"
                                type="text"
                                placeholder="Town/City"
                                onChange={this.handleChange}
                                value={city}
                                readOnly={true}
                            >
                                Town/City
                            </AddressInputField>

                        </div>

                    </div>
                )
            case 'storage':
                return (
                    <div className="quote__form__group form__w100 address">
                        <div className="quote__form__group form__w100 address__lookup wrap_margin">
                            <Autocomplete
                                suggestions={storageLocations}
                                onSuggestionsFetchRequested={this.onStorageLocationsFetchRequested}
                                onSuggestionsClearRequested={this.onStorageLocationsClearRequested}
                                getSuggestionValue={this.getStorageLocationValue}
                                renderSuggestion={this.renderSuggestion}
                                inputProps={{
                                    placeholder: 'Find storage facility by name',
                                    value: storageLocationValue,
                                    onChange: this.onStorageLocationChange,
                                }}
                                onSuggestionSelected={this.onStorageLocationSelected}
                            />
                        </div>

                        <div
                            className="address__details form__w100 active"
                        >

                            <AddressInputField
                                className=""
                                name="unit"
                                id="unit"
                                type="text"
                                placeholder="Unit number"
                                onChange={this.handleChange}
                                value={unit}
                            >
                                Unit number
                            </AddressInputField>

                            <AddressInputField
                                className=""
                                name="floor"
                                id="floor"
                                type="text"
                                placeholder="Floor number"
                                onChange={this.handleChange}
                                value={floor}
                            >
                                Floor number
                            </AddressInputField>

                            <AddressInputField
                                className=""
                                name="city"
                                id="city"
                                type="text"
                                placeholder="Town/City"
                                onChange={this.handleChange}
                                value={city}
                                readOnly={true}
                            >
                                Town/City
                            </AddressInputField>

                        </div>

                    </div>
                )
            default:
                return (
                    <div className="quote__form__group form__w100 address">
                        {
                            isAddressLookupByTermShown ?
                                <div>
                                    <div className="quote__form__group address__lookup">
                                        <label>Find address (enter postcode)</label>
                                        <input
                                            name="postcode"
                                            id="postcode"
                                            type="text"
                                            placeholder="Find address (enter postcode)"
                                            onChange={this.verifyPostcode}
                                            autoComplete="none"
                                            readOnly={this.state.addressManual}
                                            ref={(input) => { this.postcodeFindInput = input }}
                                        />
                                        <a className="address_search" onClick={this.verifyPostcode}>
                                            <SearchOrangeIcon/>
                                        </a>
                                        {(!loading && done && this.state.addressListVisible) ?
                                            AddressList(response, this.selectAddress) :
                                            null}
                                    </div>
                                    <div className="quote__form__group address__checkbox">
                                        <Checkbox
                                            last={true}
                                            first={true}
                                            short={true}
                                            onChange={this.handleCheckbox}
                                        >
                                            Manually enter address
                                        </Checkbox>
                                    </div>
                                </div>
                                : null
                        }

                        <div
                            className={
                                `address__details ${
                                    this.state.addressVisible || !isAddressLookupByTermShown ? 'active' : ''
                                }`
                            }
                        >

                            <AddressInputField
                                className="address_sub_fields address1"
                                name="addressLine1"
                                id="addressLine1"
                                type="text"
                                placeholder="Address line 1"
                                onChange={this.handleChange}
                                value=
                                    {this.props.address.getAddress.done ?
                                        this.setAddress(1) :
                                        this.state.address.addressLine1
                                    }
                                readOnly={!this.state.addressManual && isAddressLookupByTermShown}
                            >
                                Address line 1
                            </AddressInputField>

                            <AddressInputField
                                className="address_sub_fields address2"
                                name="addressLine2"
                                id="addressLine2"
                                type="text"
                                placeholder="Address line 2"
                                onChange={this.handleChange}
                                value=
                                    {this.props.address.getAddress.done ?
                                        this.setAddress(2) :
                                        this.state.address.addressLine2
                                    }
                                readOnly={!this.state.addressManual && isAddressLookupByTermShown}
                            >
                                Address line 2
                            </AddressInputField>

                            <AddressInputField
                                className="address_sub_fields address_city"
                                name="city"
                                id="city"
                                type="text"
                                placeholder="Town/City"
                                onChange={this.handleChange}
                                value={
                                    this.props.address.getAddress.response ?
                                        this.props.address.getAddress.response.City :
                                        ''
                                }
                                readOnly={!this.state.addressManual && isAddressLookupByTermShown}
                            >
                                Town/City
                            </AddressInputField>

                            <AddressInputField
                                className="address_sub_fields address_postcode"
                                name="postcode"
                                id="postcode"
                                type="text"
                                placeholder="Postcode"
                                onChange={this.handleChange}
                                value={
                                    this.props.address.getAddress.response ?
                                        this.props.address.getAddress.response.PostalCode :
                                        ''
                                }
                                readOnly={!this.state.addressManual && isAddressLookupByTermShown}
                            >
                                Postcode
                            </AddressInputField>

                        </div>

                    </div>
                )
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Address/AddressLookup.tsx